import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { resetAll } from '../resetState.action';

interface InitialState {
    activeRent?: any;
}

const initialState: InitialState = {
    activeRent: undefined,
};

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setActiveRent: (state, { payload }) => {
            state.activeRent = payload;
        },
    },
    extraReducers: (builder) => builder.addCase(resetAll, () => initialState),
});

// selectors
export const getActiveRent = (state: RootState) => state.rent.activeRent;

// actions & reducer
export const { actions, reducer } = appSlice;
